import { render, staticRenderFns } from "./VerificationsChart.vue?vue&type=template&id=b067eebc"
import script from "./VerificationsChart.vue?vue&type=script&lang=js"
export * from "./VerificationsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports